var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-badge',{directives:[{name:"gl-tooltip",rawName:"v-gl-tooltip"}],attrs:{"title":_vm.title,"variant":"warning","data-testid":"locked-badge"}},[_c('gl-icon',{attrs:{"name":"lock"}}),_vm._v(" "),_c('span',{staticClass:"gl-sr-only"},[_vm._v(_vm._s(_vm.__('Locked')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }